import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = process.env.REACT_APP_DATA_ENCRYPTION_KEY;
// Derivar la clave usando SHA-256 y convertirla a WordArray
const KEY = CryptoJS.SHA256(ENCRYPTION_KEY);

export function decryptData(data) {
  try {
    const { en, iv } = data.data;

    if (!en || !iv) {
      console.error("Datos faltantes: en o iv");
      return null;
    }

    // Convertir IV a formato WordArray
    const ivWords = CryptoJS.enc.Hex.parse(iv);

    // Descifrar directamente usando el string en base64
    const decrypted = CryptoJS.AES.decrypt(
      en,  // Usar directamente el string base64
      KEY,           // Usar la clave completa
      {
        iv: ivWords,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    // Convertir el resultado a string
    const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);

    if (!decryptedStr) {
      console.error("El contenido descifrado está vacío");
      return null;
    }

    return JSON.parse(decryptedStr);

  } catch (error) {
    console.error("Error al descifrar:", error);
    console.error("Stack:", error.stack);
    return null;
  }
}